import styled from "styled-components";
import { Grid, IconButton } from "@mui/material";

export const Wrapper = styled.div`
  position: relative;
`;

export const GridContainer = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
}));
GridContainer.defaultProps = {
  container: true,
  columnSpacing: 2,
  rowSpacing: 2,
};

export const HiddenBlock = styled.div`
  display: none;
`;

export const ClearSignButton = styled(IconButton)(() => ({
  "&.MuiButtonBase-root": {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: 0,

    svg: {
      height: "45px",
      width: "45px",
    },
  },
}));
ClearSignButton.defaultProps = {
  size: "large",
  color: "warning",
};
